import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
    designer: string;
    designPath: string;
    stockPaths: string[];
}

const StockUsageExample: React.SFC<Props> = props => {
    const { designer, designPath, stockPaths } = props;

    return (
        <div className="stock-example">
            <div className="stock-example__design">
                <img src={designPath} />
                <span className="stock-example__design__attribution">
                    <span className="attribution">
                        <FormattedMessage id="attribution" values={{ designer }} />
                    </span>
                </span>
            </div>
            <div className="stock-example__body">
                <div className="stock-example__text">
                    {' '}
                    <FormattedMessage id="stock_images.tooltip_message" />:
                </div>
                {stockPaths.map((path: any) => (
                    <img key={path} className="stock-example__stock" src={path} />
                ))}
            </div>
        </div>
    );
};

export default StockUsageExample;
